import React from "react";
import { apollo_useStyles, options_matchtype } from "../../atom/Apollo_styles";
import { checkMessageTextInvalidStartURLPattern, checkMessageTextInvalidCharURLPattern, reWhitespace, reBannedChars, reHttpsPrefix } from "../../common/Apollo_CommonUtil";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { Controller } from "react-hook-form";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const MeasureConditionsFields: React.FC<{ conditionIndex: number, index: number, removeConditions: any, formHooks: any }> = ({ conditionIndex, index, removeConditions, formHooks }) => {
  const fieldPrefix = `urlPatterns[${conditionIndex}]`;
  const classes = apollo_useStyles();

  const[matchType, setMatchType] = React.useState(1);

  const handleChange = (event: any) => {
    setMatchType(event.value);
  }

  return (
    <ListItem className={classes.listItem} key={index} >
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={1}>
          <Button type="button"
            variant="contained"
            color="secondary"
            onClick={removeConditions(conditionIndex)}>削除</Button>
        </Grid>
        <Grid item xs={2}>
          <Controller
            id={`${fieldPrefix}.matchType`}
            name={`${fieldPrefix}.matchType`}
            closeMenuOnSelect={true}
            defaultValue={options_matchtype[0]}
            render={({onChange, value}) => (
              <Select
                components={animatedComponents}
                options={options_matchtype}
                onChange={(e) => {
                  onChange(e)
                  handleChange(e)
                }}
                value={value ? value : 1}
              ></Select>
            )}
            control={formHooks.control}
          />
        </Grid>
        <Grid item xs={8}>
          <TextField
            id={`${fieldPrefix}.pattern`}
            name={`${fieldPrefix}.pattern`}
            type="text"
            required
            inputRef={formHooks.register({
                required: "必須入力項目です。",
                maxLength: {
                    value: 255,
                    message: "255文字以下を入力して下さい。"
                },
                validate: (value: string) => {
                    // ① 空白チェック（常時）
                    if (reWhitespace.test(value)) {
                        return checkMessageTextInvalidCharURLPattern;
                    }

                    // ② 禁止文字チェック（常時）
                    if (reBannedChars.test(value)) {
                        return checkMessageTextInvalidCharURLPattern;
                    }

                    // ③ matchType=1(前方一致) の場合のみ https 必須
                    if (matchType === 1) {
                        if (!reHttpsPrefix.test(value)) {
                            return checkMessageTextInvalidStartURLPattern;
                        }
                    }
                    return true;
                }
            })}
            label={"pattern" + index}
            fullWidth
            helperText={formHooks.errors?.urlPatterns && formHooks.errors?.urlPatterns[conditionIndex]?.pattern?.message}
            error={formHooks.errors?.urlPatterns && formHooks.errors?.urlPatterns[conditionIndex]?.pattern ? true : false}
          />
        </Grid>
        <Grid item xs={1}>
          OR
        </Grid>
      </Grid>
    </ListItem>
  );
};

export const MeasureConditions: React.FC<{ conditionIndexes: number[], addConditions: any, removeConditions: any, formHooks: any }> = ({ conditionIndexes, addConditions, removeConditions, formHooks }) => {
  return (
    <React.Fragment>
      <Button type="button"
        variant="contained"
        color="primary"
        onClick={addConditions(conditionIndexes)}>
        URLパターン追加
      </Button>
      <List disablePadding >
        {
          conditionIndexes?.map((conditionIndex, index: number) =>
            <MeasureConditionsFields
              key={conditionIndex}
              conditionIndex={conditionIndex}
              index={index}
              removeConditions={removeConditions}
              formHooks={formHooks} />
          )
        }
      </List>
    </React.Fragment>
  )
};